import type { ItemType } from 'src/constants/account-link';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { DialogTitle } from '@savvy-kit/components/dialog';
import { cn } from '@savvy-kit/lib/utils';
import TrackedDialog from 'src/components/tracked/tracked-dialog';
import { ClientUserIdContext } from 'src/contexts/client-user-id-context';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

import AddItemContentWrapper from './add-item-content-wrapper';
import AddItemTypeSelector from './add-item-type-selector';

type AddItemDialogProps = {
  readonly onSuccess: Deprecated_HandleItemUpdate;
  readonly onClose: () => void;
  readonly initialItemType?: ItemType;
  readonly hiddenFromClient?: boolean;
};

export default function AddItemDialog({ onSuccess, onClose, initialItemType, hiddenFromClient }: AddItemDialogProps) {
  const [itemType, setItemType] = useState(initialItemType);
  const isSmallScreen = useIsSmallScreen();
  return (
    <TrackedDialog
      elementName="add-item-dialog"
      open
      onOpenChange={(nextOpen) => !nextOpen && onClose()}
      size={isSmallScreen ? 'fullscreen' : undefined}
      className={cn('flex flex-col p-0', !isSmallScreen && 'max-h-[85vh]')}
    >
      <DialogTitle className="sr-only">Add item</DialogTitle>
      {/* pt-20 clears the content's absolute ItemDialogBackButton (top-6 + h-10). */}
      <div className={cn('min-h-0 flex-1 overflow-y-auto px-6 pb-6', itemType ? 'pt-20' : 'pt-6')}>
        {!itemType && <AddItemTypeSelector setItemType={setItemType} />}
        {itemType && (
          <ClientUserIdContext.Consumer>
            {(clientUserId) => (
              <AddItemContentWrapper
                itemType={itemType}
                clientUserId={clientUserId}
                onSuccess={onSuccess}
                hiddenFromClient={hiddenFromClient}
                setItemType={setItemType}
              />
            )}
          </ClientUserIdContext.Consumer>
        )}
      </div>
    </TrackedDialog>
  );
}
